<mat-form-field>
  <mat-label>{{ this.label }}</mat-label>
  <mat-select
    [(ngModel)]="selectedUser"
    (ngModelChange)="emitChange()"
    [disabled]="disabled"
    [required]="true"
    name="editor"
    data-cy="user-select">
    <mat-option
      *ngIf="fallBackInfo?.userId && userIdNotActive"
      [value]="fallBackInfo?.userId"
      [disabled]="true">
      {{ fallBackInfo?.firstName }} {{ fallBackInfo?.lastName }}</mat-option
    >
    <mat-option
      *ngFor="let user of users"
      [value]="user._id">
      {{ user.firstName }} {{ user.lastName }}
    </mat-option>
  </mat-select>
</mat-form-field>
